import React, {
  useCallback,
  useContext,
  useState,
} from 'react';
import format from 'string-template';

import AnnouncementContext from '../../../../../context/AnnouncementContext';
import { PrimaryButton } from '../../../../../../components/Button/ActionButtons';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import LoadingOverlay from '../../../../../components/LoadingOverlay';
import useToast from '../../../../../hooks/useToast';
import useComponentMounted from '../../../../../../hooks/useComponentMounted';

import texts from './texts.json';

const MarkAllReadButton = () => {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isComponentMountedRef = useComponentMounted();
  const { showToast } = useToast();
  const { coachUnreadComments } = useContext(AnnouncementContext);

  const markAllAsRead = useCallback(async () => {
    try {
      setIsLoading(true);
      await Promise.all(
        coachUnreadComments.map((comment) => comment.markAsRead()),
      );
      if (isComponentMountedRef.current) {
        setIsConfirmDialogOpen(false);
        showToast(texts.successMessage);
      }
    } catch (error) {
      showToast(format(texts.failedMessage, { error: error.message }), { error: true });
    } finally {
      setIsLoading(false);
    }
  }, [
    coachUnreadComments,
    isComponentMountedRef,
    showToast,
  ]);

  return (
    <>
      <PrimaryButton
        variant="light"
        size="medium"
        onClick={() => setIsConfirmDialogOpen(true)}
        disabled={isLoading || !coachUnreadComments.length}
      >
        {texts.title}
      </PrimaryButton>
      <LoadingOverlay isLoading={isLoading} />
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onCancel={() => setIsConfirmDialogOpen(false)}
        onConfirm={markAllAsRead}
        dialogTexts={{
          title: texts.title,
          content: format(texts.description, {
            count: coachUnreadComments.length,
          }),
        }}
      />
    </>
  );
};

export default MarkAllReadButton;
